import { isMobileOnly } from 'react-device-detect';
import { colors } from '@constants/colors';

export const useStyles = () => {
  return {
    title: {
      fontSize: isMobileOnly ? 18 : 26,
      lineHeight: 1,
      // fontWeight: 700,
      fontFamily: 'Primary-Bold',
      textAlign: 'left',
      paddingRight: isMobileOnly ? '10px' : 0,
    },
    message: {
      fontFamily: '"Noto Sans", sans-serif',
      fontSize: isMobileOnly ? 12 : 16,
      fontWeight: 500,
      lineHeight: 1.5,
      textAlign: 'left',
      width: '100%',
    },
    container: {
      padding: 4,
      width: 526,
      backgroundColor: colors.black_99,
      border: '1px solid rgba(255, 255, 255, 0.25)',
      backdropFilter: 'blur(40px)',
      borderRadius: '20px',
      gap: 1,
      color: colors.white,
      alignItems: 'start',
    },
    button: {
      fontFamily: '"Noto Sans", sans-serif',
      paddingY: '7px',
      paddingX: '23px',
      fontSize: 14,
      lineHeight: 1,
      fontWeight: 500,
      borderRadius: '99px',
      width: 'content-width',
      maxWidth: '50%',
      borderWidth: '1px',

      '@media (max-width: 767px)': {
        width: 'max-content',
      },
    },
    actions: {
      display: 'flex',
      flexDirection: 'row',
      gap: 2,
      width: '100%',
      justifyContent: 'end',
      alignItems: 'center',
      marginTop: 2,
    },
    secondaryButton: {
      color: colors.white,
      borderColor: colors.white,
      background: 'transparent',
    },
    close: {
      position: 'absolute',
      top: 18,
      right: 18,
      fontSize: isMobileOnly ? 16 : 12,
      color: colors.grey_200,

      cursor: 'pointer',
    },
  };
};
